import styled from "styled-components"

export const Label = styled.label`
    min-width: 14rem;
    min-height: 3rem;
    padding-left: 1.8rem;
    padding-right: 1.8rem;
    color: black;
    font-size: clamp(0.8rem, 2vw, 0.8rem);
    font-weight: 500;
    text-align: center;
    background: #9C94944D 0% 0% no-repeat padding-box;
    border: 1px solid #707070;
    opacity: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 0.2rem 0.5rem 0.2rem;
    font-family: MontserratRegular;
`

export const ListGroupContainer = styled.div`
    height: 270px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    margin-top: 15px;
    margin-bottom: 15px;
    border-right: 4px #00000029 solid;
    padding-right: 10px;

    .group-list {
        box-shadow: 0px 3px 6px #00000029;
        border-radius: 5px;
        border: 2px #00000029 solid;
        padding: 5px;
        margin-right: 3px;
    }

    .content-check {
        width: 10%;
        height: fit-content;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
`

export const SubheaderValue = styled.label`
    overflow: hidden;
    width: 100%;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: MontserratRegular;

    .inline-text {
        overflow: hidden;
        display: block-inline;
        height: 45px;
        padding: 0;
    }
`

export const ListValue = styled.label`
    width: 90%;
    display: inline-block;
    padding-top: 8px;
    padding-bottom: 5px;
`

interface TableCheck {
    color?: string
}

export const TableCheck = styled.input.attrs({ type: 'checkbox' })`
    display: inline-block;
    border: 2px #9C949480 solid;
    width: 100%;
    height: 1.2rem;
  
    &input:checked {
      background-color: ${(p: TableCheck) => "p.color"};
    }
  `